// Color/material name hover effect for desktop (>799px). Updates the
// "Color: X" and "Material: Y" labels in each color selector's header
// when a thumbnail or swatch is hovered.
//
// Scoped per .color_swatch_container so each selector variant on the page
// (image-based + swatch-based) updates its own header independently. Without
// this scoping, both variants on the same page would compete for the first
// .hint-color in the DOM.
if (window.innerWidth > 799) {
  document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('.color_swatch_container');
    wrappers.forEach((wrapper) => {
      const hints = wrapper.querySelectorAll('.hint-color');
      const colorHint = hints[0];
      const materialHint = hints[1]; // may be undefined if product has no material_label
      if (!colorHint) return;
      const originalColor = colorHint.textContent;
      const originalMaterial = materialHint ? materialHint.textContent : '';
      const tiles = wrapper.querySelectorAll('.hover-status');
      tiles.forEach((tile) => {
        const textColor = tile.querySelector('.text-hidden:not(.material-hidden)');
        const textMaterial = tile.querySelector('.material-hidden');
        const image = tile.querySelector('img');
        if (!image) return;
        image.addEventListener('mouseenter', () => {
          if (textColor) colorHint.textContent = textColor.textContent;
          if (materialHint && textMaterial && textMaterial.textContent.trim()) {
            materialHint.textContent = textMaterial.textContent;
          }
        });
        image.addEventListener('mouseleave', () => {
          colorHint.textContent = originalColor;
          if (materialHint) materialHint.textContent = originalMaterial;
        });
      });
    });
  });
}
